import React from "react";
import connection from "../../connection";
import general from "../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import feedbackStyle from "assets/jss/material-dashboard-pro-react/views/pdpeStyle";
import FormularioGenerico from "./FormularioGenerico";

class PreencherFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formulario: null,
      formacao: null,
      modalidade: this.props.modalidade
    };

    this.nav = null;

    this.submitAnswers = this.submitAnswers.bind(this);
  }

  componentDidMount() {
    // Formulário dependente da modalidade da formação
    let formulario_selecionado = {'etiqueta': 'feedback_formacao', versao: 2023};
    if (this.state.modalidade === "ELEARNING" || this.state.modalidade === "ELEARNINGASINC") {
      formulario_selecionado.etiqueta = 'feedback_formacao_online';
      formulario_selecionado.versao = 2023;
    } else if (this.state.modalidade === "ELEARNINGSINC") {
      formulario_selecionado.etiqueta = 'feedback_formacao_online_sincrona';
      formulario_selecionado.versao = 2025;
    }
    connection.get(`forms/obter/${formulario_selecionado.etiqueta}/${formulario_selecionado.versao}`, null, (data) => {
      this.setState({
        formulario: data.conteudo,
        formacao: this.props.formacaoId,
      })
    });
  }

  submitAnswers(valores) {
    connection.post("formacao/participante/submeter_feedback", {respostas: valores, formacao: this.state.formacao}, (data) => {
      if (data.success) {
        general.success("Obrigado por submeter o seu feedback da formação. Poderá visualizar a sua nota na listagem de formações.", "Sucesso");
        this.props.onFeedbackGiven && this.props.onFeedbackGiven(this.state.answers)
      } else {
        general.error("Por favor tente novamente.", "Erro!");
      }
    });
  }

  render() {
    return <FormularioGenerico formulario={this.state.formulario} onSubmit={this.submitAnswers}/>;
  }
}

export default withStyles(feedbackStyle)(PreencherFeedback);
